import { RoutePath } from "#src/utils/route";
import { WorkersRoutePath } from "..";

/** Base path for the worker definitions list and per-worker routes. Resolves to /workers/definitions. */
export const WorkersDefinitionsRoutePath = WorkersRoutePath.concat(
  new RoutePath({
    path: "/definitions",
    title: "Worker Definitions",
  })
);

/** Route path for the workers list page. Resolves to /workers/definitions. */
export const WorkerVersionsRoutePath = WorkersDefinitionsRoutePath;
